import { render, staticRenderFns } from "./TextMessageComponent.vue?vue&type=template&id=7c0337a6&scoped=true"
import script from "./TextMessageComponent.vue?vue&type=script&lang=js"
export * from "./TextMessageComponent.vue?vue&type=script&lang=js"
import style0 from "./TextMessageComponent.vue?vue&type=style&index=0&id=7c0337a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0337a6",
  null
  
)

export default component.exports